import React, {useEffect} from "react";

declare let QRLogin: any;
export default function FSLogin() {
    useEffect(() => {
        const goto = "https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a61591aa4dfed00d&redirect_uri=https://yunhuiju.pro/fs-login-handler&response_type=code";
        const QRLoginObj = QRLogin({
            id: "login_container",
            goto,
            width: "500",
            height: "500",
            style: "width:500px;height:600px"//可选的，二维码html标签的style属性
        });

        const handleMessage = (event: any) => {
            // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
            if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
                const loginTmpCode = event.data.tmp_code;
                // 在授权页面地址上拼接上参数 tmp_code，并跳转
                window.location.href = `${goto}&tmp_code=${loginTmpCode}`;
            }
        };

        if (typeof window.addEventListener != 'undefined') {
            window.addEventListener('message', handleMessage, false);
            // @ts-ignore
        } else if (typeof window.attachEvent != 'undefined') {
            // @ts-ignore
            window.attachEvent('onmessage', handleMessage);
        }
    }, []);

    return <div className={'flex justify-center items-center w-full h-100vh'}>
        <div id="login_container"></div>
    </div>
}